var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home publicVCenter"},[_c('top-header'),_c('banner'),_c('section-one'),_c('section-two'),_c('section-three'),_c('section-four'),_c('section-five'),_c('section-six'),_c('my-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }